import types from 'pages/Orders/actions/types';
import { getDefaultOrderListFilter } from 'pages/Orders/helpers/constans';
import { createRequestKey } from 'utils/dedupeRequest';

const emptyOrdersData = () => ({
  items: [], itemsPerPage: 0, page: 0, totalItems: 0, totalPages: 0,
});

const INITIAL_STATE = {
  query: { ...getDefaultOrderListFilter(), order_status: -1 },

  loadingList: false,
  listError: null,
  activeRequestId: 0,
  dataOrders: emptyOrdersData(),
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_QUERY_REQUEST:
      return {
        ...state,
        ...(createRequestKey('orders', action.payload) !== createRequestKey('orders', state.query)
          ? { dataOrders: emptyOrdersData(), listError: null, loadingList: true, activeRequestId: 0 } : {}),
        query: action.payload,
      };
    case types.GET_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        listError: null,
        dataOrders: emptyOrdersData(),
        activeRequestId: action.meta?.requestId || 0,
      };
    case types.GET_LIST_REQUEST_FAILE:
      if (action.meta?.requestId !== state.activeRequestId) return state;
      return {
        ...state,
        loadingList: false,
        dataOrders: emptyOrdersData(),
        listError: action.payload?.message || 'Không tải được danh sách đơn hàng.',
      };
    case types.GET_LIST_REQUEST_SUCCESS:
      if (action.meta?.requestId !== state.activeRequestId) return state;
      return {
        ...state,
        loadingList: false,
        listError: null,
        dataOrders: action.payload,
      };
    default:
      return state;
  }
}
